import PropTypes from 'prop-types'
import React from 'react'

const Progress = props => {
  const { max, value, className, showLabel, label } = props
  return (
    <div className={`progress ${className}`}>
      {showLabel && (
        <div className="progress__label">
          {label ? label : `Showing ${value} of ${max} items`}
        </div>
      )}
      <progress max={max} value={value} />
    </div>
  )
}

Progress.propTypes = {
  className: PropTypes.any,
  max: PropTypes.any,
  showLabel: PropTypes.any,
  value: PropTypes.any,
  label: PropTypes.string
}

export default Progress
